import { runJsonPost, runUnauthenticatedJsonPost } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { transformKeysToCamelCase } from './utils/casing'

const COMMANDS_BASE_URL = OPERATIONS_BACKEND_URL + '/accounts/commands'
const QUERIES_BASE_URL = OPERATIONS_BACKEND_URL + '/accounts/queries'

export interface SendNew {
  newPassword1: string
  newPassword2: string
  agreedToReceiveNewsletter: boolean
  token: string
  uid: string
}

export async function checkResetLinkExpiration(personId, token) {
  const response = await runJsonPost(
    `${QUERIES_BASE_URL}/password-reset-token-validity/${personId}`,
    { token }
  )
  return transformKeysToCamelCase(response.data)
}

export async function sendResetEmail(personId) {
  await runJsonPost(
    `${COMMANDS_BASE_URL}/send-account-activation-password-reset-email/${personId}`
  )
}

export async function updatePersonRegistrationStatus(personId) {
  await runJsonPost(
    `${COMMANDS_BASE_URL}/update_person_registration_status/${personId}`,
    { registration_status: 'COMPLETED' }
  )
}

export async function validate(personId, password) {
  const { data } = await runJsonPost(`${COMMANDS_BASE_URL}/validate_password/`, {
    person_id: personId,
    password
  })
  const { detectedValidationErrors } = transformKeysToCamelCase(data)
  return detectedValidationErrors
}

export async function sendNew({
  newPassword1,
  newPassword2,
  agreedToReceiveNewsletter,
  token,
  uid
}) {
  await runUnauthenticatedJsonPost(
    `${OPERATIONS_BACKEND_URL}/accounts/commands/password-reset-confirm`,
    {
      new_password1: newPassword1,
      new_password2: newPassword2,
      agreed_to_newsletter_terms: agreedToReceiveNewsletter,
      token,
      uid
    }
  )
}

export async function sendNewForgotten({
  newPassword1,
  newPassword2,
  agreedToReceiveNewsletter,
  token,
  uid
}) {
  await runUnauthenticatedJsonPost(
    `${OPERATIONS_BACKEND_URL}/auth/password/reset/confirm/`,
    {
      new_password1: newPassword1,
      new_password2: newPassword2,
      agreed_to_newsletter_terms: agreedToReceiveNewsletter,
      token,
      uid
    }
  )
}

export async function sendForgottenPasswordEmail(email) {
  await runJsonPost(`${COMMANDS_BASE_URL}/send-password-reset-email`, {
    email: email
  })
}
